import { FormProvider, useForm } from "react-hook-form";
import CpntForm from "../../../../components/forms/CpntForm";
import CpntFormSection from "../../../../components/forms/CpntFormSection";
import CpntFormSectionContainer from "../../../../components/forms/CpntFormSectionContainer";
import CpntFormSectionNavigation from "../../../../components/forms/CpntFormSectionNavigation";
import { KeyCloakRoles, MessageTypeDemande, MessageTypeView,Type_Reponse_Message,typeDemandeMessageListMarques,typeDemandeMessageListNotices,validationMode } from "../../../../config/helpers";
import { IFormMessageDemande, IFormMessageReponse } from "../../../../components/IFormMessage";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { Button} from "react-bootstrap";
import { messageDemandeSchema, messageReponseSchema } from "./messageSchema";
import { useKeycloak } from "@react-keycloak/web";
// import { useFetchmessageQuery } from "../../../../redux/slice/api/messageApi";
import TextAreaInput from "../../../../components/forms/TextAreaInput";
import SelectInput from "../../../../components/forms/SelectInput";
import { IMessage } from "../../../../models/interfaces/IMessage";
import Label from "../../../../components/forms/Label";
import ConfirmDialog from "../ConfirmDialog";
import CheckboxInput from "../../../../components/forms/CheckBoxInput";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { formatDateHeure_fns } from "../../../../utils/helpers";
import { format } from 'date-fns';
import { MESSAGE_DEMANDE_REFUS_DEFAULT, MESSAGE_DEMANDE_VALIDE_DEFAULT } from "../../../../data/message-default";
//import ModalPrintable from "../../../../components/modalPrintable/ModalPrintable";

interface IProps {
    Message?: IMessage;
    typeView?: MessageTypeView;
    typeDemande?: MessageTypeDemande;
    enregistrerDemande?: (data: IFormMessageDemande) => void;
    supprimerDemande?: (data: number) => void;
    enregistrerReponse?: (data: IFormMessageReponse) => void;
    bloquerReponse?: (bloquer: boolean) => void;
  }

  //Il doit y avoir un mode demandeur et un mode receveur
  //Statu nouveau...
const MessageView: React.FC<IProps> = ({
  Message,
  typeView,
  typeDemande,
  enregistrerDemande,
  supprimerDemande,
  enregistrerReponse,
  bloquerReponse
}:IProps) => {


  const { initialized: keycloakinitialized,keycloak } = useKeycloak();
  const compte = useSelector((state: RootState) => state.compte);
 
  const [isDialogOpen, setDialogOpen] = useState(false);



  //Demande
  const [idTypeDemandeValue,setIdTypeDemandeValue] = useState<number|undefined>(undefined);
  const [nouvelleDemande,setNouvelleDemande] = useState<boolean>(false);
    

  const formMethodsDemande = useForm<IFormMessageDemande>({
    mode: "all",
    reValidateMode: "onChange",
    resolver: yupResolver(messageDemandeSchema),
  });

  const { handleSubmit:handleSubmitDemande,reset:resetDemande,watch:watchDemande } = formMethodsDemande;

  const listDemande = typeDemande === MessageTypeDemande.Notice 
  ? typeDemandeMessageListNotices 
  : typeDemandeMessageListMarques;

  const TypeDemande = listDemande.find(tdmln => tdmln.Id === watchDemande("IdTypeDemande"))?.Libelle ?? "";
  const messageDemande = watchDemande("MessageDemande");
 
  const onErrorDemande = (errors: any) => {
  };


  //Reponse
  const [reponseAutorise,setReponseAutorise] = useState<boolean>(false);  
  const [idTypeReponseValue,setIdTypeReponseValue] = useState<number|undefined>(undefined);

  const formMethodsReponse = useForm<IFormMessageReponse>({
    mode: "all",
    reValidateMode: "onChange",
    resolver: yupResolver(messageReponseSchema),
  });

  const { handleSubmit:handleSubmitReponse,reset:resetReponse,watch:watchReponse } = formMethodsReponse;
  const idTypeReponseTemp = watchReponse("IdTypeReponse");

  const deleteHandler = () => {
    setDialogOpen(true); // Ouvrir le modal de confirmation
  };
  
  const handleConfirm = () => {
    setDialogOpen(false);
    !isNaN(Number(Message?.Id)) && supprimerDemande && supprimerDemande(Number(Message?.Id));
  };
  
    const handleCancel = () => {
    setDialogOpen(false);
  };

  const handleBloquer = (e:any) => {
    const { checked } = e.target;
    if (Message?.IdPersonneReponse === compte.IdPersonne || Message?.IdPersonneReponse === undefined || !Message?.IdPersonneReponse) {
      setIdTypeReponseValue(checked ? Type_Reponse_Message.TraitementEnCours : Type_Reponse_Message.Nouveau)
      bloquerReponse && bloquerReponse(checked);
      //init reponse...
      setReponseAutorise(false);
      resetReponse({
        MessageReponse: ""
      });
    }
  };

  const onErrorReponse = (errors: any) => {
  };




  useEffect(() => {
    if (Message) {
      resetDemande({
        IdTypeDemande: Message.IdTypeDemande,
        MessageDemande: Message.MessageDemande,
      });
      setIdTypeDemandeValue(Message.IdTypeDemande);

      resetReponse({
        IdTypeReponse: Message.IdTypeReponse,
        MessageReponse: Message.MessageReponse,
      });
      setIdTypeReponseValue(Message.IdTypeReponse);
    } else {
      resetDemande({
        IdTypeDemande: undefined,
        MessageDemande: "",
      });
      setIdTypeDemandeValue(undefined);

      resetReponse({
        IdTypeReponse: undefined,
        MessageReponse: "",
      });
      setIdTypeReponseValue(undefined);
    }

  }, [Message])

  const DemandeFoResponsable = () => {
    let insideBloc = <></>;

    const _TypeReponse = Message ? Message?.IdTypeReponse : Type_Reponse_Message.Nouveau;
    
    switch (_TypeReponse) {
      case Type_Reponse_Message.Nouveau:
        insideBloc = <FormProvider {...formMethodsDemande}>
        <form onSubmit={handleSubmitDemande((data) => enregistrerDemande !== undefined && enregistrerDemande(data) ,onErrorDemande)}>
          <CpntForm>
            <CpntFormSection pSectionLabel="Demande de modification">
                  <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12,12,12,12]}>
                  {Message?.DateDemande && <Label label={`Demandée le ${Message?.DateDemande && format(Message?.DateDemande,formatDateHeure_fns)} `} />}
                  {Message?.PersonneDemande && <Label label={`Par ${Message?.PersonneDemande} `} />}
                  {typeDemande === MessageTypeDemande.Societe ? (
                      <SelectInput
                        label="Demande"
                        formName="IdTypeDemande"
                        ismandatory={true}
                        options={[
                          ...listDemande.map((tm) => ({
                            Libelle: tm.Libelle,
                            Id: tm.Id,
                          }))
                        ]}
                      />
                    ) : (
                      <SelectInput
                        label="Demande"
                        formName="IdTypeDemande"
                        ismandatory={true}
                        disabled={false} // Enable the SelectInput
                        options={[
                          { Libelle: "Sélectionnez une demande", Id: "" },
                          ...listDemande.map((tm) => ({
                            Libelle: tm.Libelle,
                            Id: tm.Id,
                          }))
                        ]}
                      />
                    )}

                  
                   <TextAreaInput
                      label="Message de la demande"
                      formName="MessageDemande"
                      validationStyle={validationMode.classic}
                      placeholder="Message"
                      maxLength={2000}
                      rows={5}
                    />
                  </CpntFormSectionContainer>
                  <CpntFormSectionNavigation>
                    <div></div>
                    {
                      nouvelleDemande ? 
                      <Button type="button" 
                      onClick={() => {
                        setNouvelleDemande(false);
                        resetDemande({
                          IdTypeDemande: undefined,
                          MessageDemande: "",
                        });
                        setIdTypeDemandeValue(undefined);
                      }}
                      className="btn-darkgrey">
                        Annuler
                      </Button>
                      :
                      <Button type="button" onClick={deleteHandler} className="btn-red">
                      Supprimer
                    </Button>
                    }
                    <Button type="submit" className="btn-secondary">
                      Enregistrer
                    </Button>
                    <div></div>
                  </CpntFormSectionNavigation>
  
            </CpntFormSection>
          </CpntForm>
        </form>
      </FormProvider>
      break;
      case Type_Reponse_Message.TraitementEnCours:
      case Type_Reponse_Message.Valide:
      case Type_Reponse_Message.Refuse:
        insideBloc = <FormProvider {...formMethodsDemande}>
          <form>
            <CpntForm>
              <CpntFormSection pSectionLabel="Demande de modification">
                <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12,12,12,12]}>
                {Message?.DateDemande && <Label label={`Demandée le ${Message?.DateDemande && format(Message?.DateDemande,formatDateHeure_fns)} `} />}
                {Message?.PersonneDemande && <Label label={`Par ${Message?.PersonneDemande} `} />}
                  <Label label="Demande" ismandatory={true} />
                  <input type="text" value={TypeDemande} className="form-control" disabled={true} />
                  <Label label="Message de la demande" ismandatory={true} />
                  <textarea 
                    value={messageDemande} 
                    className="form-control" 
                    disabled={true} 
                    rows={5}
                  />
                </CpntFormSectionContainer>
              </CpntFormSection>
            </CpntForm>
          </form>
        </FormProvider>
      break;
      default:
        insideBloc = <></>
      break;
    }

   
    
    return insideBloc
  };

  const DemandeFoNonResponsable = () => {
    let insideBloc = <></>;

    const _TypeReponse = Message ? Message?.IdTypeReponse : Type_Reponse_Message.Nouveau;
   
    switch (_TypeReponse) {
      case Type_Reponse_Message.Nouveau:
      case Type_Reponse_Message.TraitementEnCours:
      case Type_Reponse_Message.Valide:
      case Type_Reponse_Message.Refuse:
        insideBloc = <FormProvider {...formMethodsDemande}>
          <form>
            <CpntForm>
              <CpntFormSection pSectionLabel="Demande de modification">
                <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12,12,12,12]}>
                {Message?.DateDemande && <Label label={`Demandée le ${Message?.DateDemande && format(Message?.DateDemande,formatDateHeure_fns)} `} />}
                {Message?.PersonneDemande && <Label label={`Par ${Message?.PersonneDemande} `} />}
                  <Label label="Demande" ismandatory={true} />
                  <input type="text" value={TypeDemande} className="form-control" disabled={true} />
                  <Label label="Message de la demande" ismandatory={true} />
                  <textarea 
                    value={messageDemande} 
                    className="form-control" 
                    disabled={true} 
                    rows={5}
                  />
                </CpntFormSectionContainer>
              </CpntFormSection>
            </CpntForm>
          </form>
        </FormProvider>
      break;
      default:
        insideBloc = <></>
      break;
    }

   
    
    return insideBloc
  };

  const DemandeBo = () => {
    //const insideBloc = <></>
    return <FormProvider {...formMethodsDemande}>
          <form>
            <CpntForm>
              <CpntFormSection pSectionLabel="Demande de modification">
                <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12,12]}>
                {Message?.DateDemande && <Label label={`Demandée le ${Message?.DateDemande && format(Message?.DateDemande,formatDateHeure_fns)} `} />}
                {Message?.PersonneDemande && <Label label={`Par ${Message?.PersonneDemande} `} />}
                <Label label="Demande de modification" ismandatory={true} />
                <input type="text" value={TypeDemande} className="form-control" disabled={true} />
                <Label label="Message de la demande" ismandatory={true} />
                <textarea 
                    value={messageDemande} 
                    className="form-control" 
                    disabled={true} 
                    rows={5}
                  />
                </CpntFormSectionContainer>
              </CpntFormSection>
            </CpntForm>
          </form>
        </FormProvider>
  };

  const FormDemande = (
    <>
      {
      ((idTypeDemandeValue === undefined || idTypeDemandeValue <1) && !nouvelleDemande) ? 
      (
        <>
          <Button type="button" className="col-12 btn-secondary" onClick={() => setNouvelleDemande(true)}>Demander une modification</Button>
        </>
      ) 
      : (
        <>
            {keycloakinitialized && keycloak?.hasRealmRole(KeyCloakRoles.ElectreFO.toString()) && (!Message?.IdPersonneDemande || Message?.IdPersonneDemande === compte.IdPersonne ) && DemandeFoResponsable()}
            {keycloakinitialized && keycloak?.hasRealmRole(KeyCloakRoles.ElectreFO.toString()) && (Message?.IdPersonneDemande && Message?.IdPersonneDemande !== compte.IdPersonne) && DemandeFoNonResponsable()}
            {keycloakinitialized && keycloak?.hasRealmRole(KeyCloakRoles.ElectreBO.toString()) && DemandeBo()}
        </>
     )
     }
     </>
   );
 
  const ReponseFo = () => {
  let insideBloc = <></>;
  switch (Message?.IdTypeReponse) {
    case Type_Reponse_Message.Nouveau:
      insideBloc = <><i className="bi bi-hourglass-split "></i><i className="ps-2">Votre demande n&apos;a pas encore été prise en charge par nos services. Vous pouvez encore la compléter, la modifier ou la supprimer si nécessaire.</i></>
    break;
    case Type_Reponse_Message.TraitementEnCours:
      insideBloc = <><i className="bi bi-eyeglasses"></i><i className="ps-2">Votre demande est prise en charge par nos services.<br/>Vous ne pouvez plus la modifier.<br/>La réponse sera visualisable ici après traitement.</i></>
    break;
    case Type_Reponse_Message.Valide:
      insideBloc = <>
      <i className="bi bi-check-circle-fill text-green"></i><i className="ps-2">Votre demande est validée</i><br /><br />
      Message de la réponse :<div>{Message?.MessageReponse}</div>
      </>
    break;
    case Type_Reponse_Message.Refuse:
      insideBloc = <>
      <i className="bi bi-x-circle-fill text-reddark"></i><i className="ps-2">Votre demande est refusée</i><br /><br />
      <div dangerouslySetInnerHTML={{ __html: Message?.MessageReponse?.replace(/\n/g, '<br />') || '' }}></div>

      </>
    break;
    default:
      insideBloc = <></>
    break;
  }
  
  return <CpntForm>
      <CpntFormSection pSectionLabel="Concernant votre demande">
          <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12, 12]}>
        {insideBloc}
        </CpntFormSectionContainer>
      </CpntFormSection>
  </CpntForm>
  }

  const ReponseBoResponsable = () => {
    const _TypeReponse = idTypeReponseValue //;Message ? Message?.IdTypeReponse : Type_Reponse_Message.Nouveau;
    //Personne connecté != personne qui repond
    switch (_TypeReponse) {
      case Type_Reponse_Message.TraitementEnCours:
        
        return !reponseAutorise ? <>
            <Button type="button" 
                  onClick={() => {
                    setReponseAutorise(true);
                    //setIdTypeReponseValue(Type_Reponse_Message.Refuse);
                    resetReponse({
                      MessageReponse:MESSAGE_DEMANDE_REFUS_DEFAULT,
                      IdTypeReponse:Type_Reponse_Message.Refuse,
                    });
                  }} 
                  className="col-5 btn-red">
                    Refuser la demande
                  </Button>
                  <Button type="button" 
                  onClick={() => {
                    setReponseAutorise(true);
                    //setIdTypeReponseValue(Type_Reponse_Message.Valide);
                    resetReponse({
                      MessageReponse:MESSAGE_DEMANDE_VALIDE_DEFAULT,
                      IdTypeReponse:Type_Reponse_Message.Valide,
                    });
                  }} 
                  className="offset-1 col-5 btn-secondary">
                    Valider la demande
                  </Button>
                </> :
                <>
                   <TextAreaInput
                      label= {`Message ${idTypeReponseTemp === Type_Reponse_Message.Valide ? "de validation" : "de refus"}`}
                      formName="MessageReponse"
                      validationStyle={validationMode.classic}
                      placeholder="Message"
                      maxLength={2000}
                      className="TextAreaMessage"
                    />
                    <Button className="offset-1 col-5 btn-darkgrey"
                    onClick={() => {
                      setReponseAutorise(false);
                      resetReponse({
                        MessageReponse: ""
                      });
                    }} 
                    >
                      Annuler
                      </Button>
                      <Button type="submit" className="col-5 btn-secondary">
                        Enregistrer
                      </Button>
                </>
      break;
      case Type_Reponse_Message.Valide:
        return <>
            <div><i className="bi bi-check-circle-fill text-green"></i><i className="ps-2">La demande a été validée</i></div>
            <div>Message : {Message?.MessageReponse}</div>
          </>
      break;
      case Type_Reponse_Message.Refuse:
        return <>
            <div><i className="bi bi-x-circle-fill text-reddark"></i><i className="ps-2">La demande a été refusée</i></div>
            <div>Message : {Message?.MessageReponse}</div>
          </>
      break;
    }
  }

  const ReponseBoNonResponsable = () => {
        const _TypeReponse = idTypeReponseValue //;Message ? Message?.IdTypeReponse : Type_Reponse_Message.Nouveau;

          //Personne connecté == personne qui repond
          switch (_TypeReponse) {
          case Type_Reponse_Message.TraitementEnCours:
            return <>
                    <div>{`La demande a été pris en charge par ${Message?.PersonneReponse}`}</div>
                    </>
          break;
          case Type_Reponse_Message.Valide:
            return <>
                <div><i className="bi bi-check-circle-fill text-green"></i><i className="ps-2">{`La demande a été validée par ${Message?.PersonneReponse}`}</i></div>
                <div>Message : {Message?.MessageReponse}</div>
              </>
          break;
          case Type_Reponse_Message.Refuse:
            return <>
                <div><i className="bi bi-x-circle-fill text-reddark"></i><i className="ps-2">{`La demande a été refusée par ${Message?.PersonneReponse}`}</i></div>
                <div>Message : {Message?.MessageReponse}</div>
              </>
          break;
        }
            
  }

 const ReponseBo = () => {

      return <>
      {Message && compte?.Id &&
        <FormProvider {...formMethodsReponse}>
             <form
              onSubmit={handleSubmitReponse((data) => {
                if (enregistrerReponse !== undefined) {
                  enregistrerReponse(data); 
                  setIdTypeReponseValue(data.IdTypeReponse); 
                }
              },onErrorReponse)}
            ><CpntForm>
              <CpntFormSection pSectionLabel="La réponse d'Electre">
                <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12, 12,12]}>
                {
                  //Personne non définie ou responsable
                  (Message?.IdPersonneReponse === compte.IdPersonne || !Message?.IdPersonneReponse) 
                  && (idTypeReponseValue === Type_Reponse_Message.Nouveau ||idTypeReponseValue === Type_Reponse_Message.TraitementEnCours) 
                  &&
                    <CheckboxInput 
                    label="Je prends en charge la demande" 
                    formName="chkGetReponse"
                    onChange={handleBloquer}
                    options={[
                      {
                        name: "",
                        value: "LOCK", 
                        defaultChecked: Message?.IdPersonneReponse === compte.IdPersonne ? "LOCK" : ""
                      },
                    ]}     
                    ></CheckboxInput>
                  }
                  {(Message?.IdPersonneReponse === compte.IdPersonne) && ReponseBoResponsable()}
                  {(Message?.IdPersonneReponse !== compte.IdPersonne) && ReponseBoNonResponsable()}
                </CpntFormSectionContainer>
              </CpntFormSection>
            </CpntForm>
            </form>
        </FormProvider>
           }
    </>
   };

  const FormReponse = (
    <>
      {(idTypeDemandeValue && idTypeDemandeValue === undefined || !idTypeDemandeValue || idTypeReponseValue === undefined) ? (
        <CpntForm>
          <CpntFormSection pSectionLabel="Une demande de correction à faire ?">
              <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12, 12]}>
                <div>
                  <i className="bi bi-info-circle-fill"></i><i className="ps-2">Si une modification est nécessaire, veuillez nous en informer en soumettant une demande de correction ci-contre.</i>
                </div>
              </CpntFormSectionContainer>
          </CpntFormSection>
        </CpntForm>
      ) 
      : 
      (
        <>
          {keycloakinitialized && keycloak?.hasRealmRole(KeyCloakRoles.ElectreFO.toString()) && ReponseFo()}
          {keycloakinitialized && keycloak?.hasRealmRole(KeyCloakRoles.ElectreBO.toString()) && ReponseBo()}
        </>
      )}
    </>
  );
      

  const SuppressionDialog = (
    <ConfirmDialog
        title="Confirmer la suppression"
        message="La demande va être supprimée"
        isOpen={isDialogOpen}
        button1Libelle="Annuler"
        button2Libelle="Confirmer"
        button1ClassName="btn-darkgrey"
        button2ClassName="btn-red btn"
        onButton1={handleCancel}
        onButton2={handleConfirm}
      />);


  return (
      <div className="col-sm-6 ">
           {/* <div className="card row">  */}
              <div className="card-body">
                {(typeView === MessageTypeView.Demande) && FormDemande}
                {(typeView === MessageTypeView.Reponse) && FormReponse}
              </div> 
              {SuppressionDialog}
          {/* </div> */}
      </div>
  );


   

  
};

export default MessageView;